import { render, staticRenderFns } from "./BookingCalendar.vue?vue&type=template&id=2d238d33&scoped=true"
import script from "./BookingCalendar.vue?vue&type=script&lang=js"
export * from "./BookingCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d238d33",
  null
  
)

export default component.exports